<template>
  <div class="mask">
    <div class="popup-wrap">
      <!-- 头部 -->
      <div class="popup-header">
        <div class="popup-header-left">扬声器设置</div>
      </div>
      <!-- 中间 -->
      <div class="popup-content">
        <!-- 顶部下拉 -->
        <div class="popup-content-top">
          <div class="popup-content-top-content">
            <div class="popup-green"></div>
            <div>扬声器设置</div>
            <div>
              <select name="" id="" class="popup-content-left-select">
                <option value="">7.14</option>
                <option value="">7.15</option>
                <option value="">7.18</option>
              </select>
            </div>
          </div>
        </div>
        <!-- 内容 -->
        <div class="popup-center">
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">左（L）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">右（R）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">中置（C）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">低频效果（LFE）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">左侧环绕（Lss）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">右侧环绕（Rss）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">左后环绕（Lrs）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">右后环绕（Rrs）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">左上前（Ltf）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">右上前（Rtf）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">左上后（Ltb）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
          <div class="popup-center-line">
            <div class="popup-center-line-text">
              <div class="img">
                <img src="/space/images/begin.svg" alt="" />
              </div>
              <div class="title">右上后（Rtb）</div>
            </div>
            <div class="line-right">
              <div>
                <select name="" id="" class="line-select">
                  <option value="">选择扬声器</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
              <div>
                <select name="" id="" class="line-select">
                  <option value="">7.14</option>
                  <option value="">7.15</option>
                  <option value="">7.18</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 底部 -->
      <div class="popup-footer">
        <div>2022-2032 © All Right Reserved by WANOS</div>
        <div class="popup-footer-right">
          <button class="return" @click="$emit('close')">返回</button>
          <button class="go" @click="$emit('close')">进入体验场</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  created() {},
  mounted() {
    console.log("获取当前设备声道数量");
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
.mask {
  position: fixed;
  top: 0%;
  left: 0%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
}
.popup-wrap {
  width: 680px;
  height: 530px;
  background: #21242b;
  box-shadow: 0px 6px 14px rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin: 30px;
}
.popup-header {
  height: 40px;
  background: #2b2f38;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  color: white;
  border-radius: 5px 5px 0 0;
  font-size: 12px;
}
.popup-content {
  width: 100%;
  height: 430px;
  .popup-content-top {
    width: 100%;
    height: 45px;
    border-bottom: solid 1px black;
    display: flex;
    align-items: center;
    .popup-content-top-content {
      width: 270px;
      display: flex;
      align-items: center;
      margin: 0 auto;
      color: #ccc;
      .popup-green {
        width: 10px;
        height: 10px;
        border-radius: 10px;
        background: greenyellow;
        margin-right: 5px;
      }
      .popup-content-left-select {
        width: 150px;
        border: 1px solid #62656e;
        background: #21242d;
        border-radius: 5px;
        color: rgb(230, 228, 228);
        font-size: 14px;
        outline: none;
        padding: 5px;
        margin-left: 15px;
        margin-bottom: 5px;
      }
    }
  }
  .popup-center {
    box-sizing: border-box;
    height: 382px;
    overflow: auto;
    width: 100%;
    padding: 15px 50px;
    .popup-center-line {
      display: flex;
      justify-content: space-between;
      margin-bottom: 5px;
      .popup-center-line-text {
        display: flex;
        align-items: center;
        color: #ccc;
        .img {
          width: 13px;
          height: 13px;
          margin-right: 10px;
        }
        .title {
          white-space: nowrap;
          width: 120px;
        }
      }
      .line-right {
        display: flex;
        & > div:first-child {
          .line-select {
            width: 120px;
          }
        }
        .line-select {
          width: 100px;
          border: 1px solid #62656e;
          background: #21242d;
          border-radius: 5px;
          color: rgb(230, 228, 228);
          font-size: 14px;
          outline: none;
          padding: 5px;
          margin-left: 5px;
          margin-bottom: 5px;
        }
      }
    }
  }
}
.popup-footer {
  height: 60px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 18px;
  border-radius: 5px 5px 0 0;
  border-top: solid 1px black;
  & > div:first-child {
    font-family: "PingFang SC";
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #727c94;
    opacity: 0.6;
  }
  color: #ccc;
  .popup-footer-right {
    display: flex;
    .return {
      background: linear-gradient(180deg, #464d59 0%, #2e333c 100%);
      box-shadow: inset 0px 1px 0px rgba(114, 124, 148, 0.34);
      border-radius: 4px;
      color: white;
      border: none;
      height: 28px;
      width: 70px;
      font-size: 12px;
      border-radius: 4px;
      margin-right: 10px;
    }
    .go {
      background: linear-gradient(180deg, #3d3dfc -12.5%, #1c1cb7 163.24%);
      box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.16);
      border-radius: 4px;
      color: white;
      border: none;
      height: 28px;
      width: 100px;
      font-size: 12px;
      border-radius: 4px;
    }
  }
}
</style>
